/* eslint-disable no-unused-vars */
import React, {useState} from 'react';

import {useDispatch, useSelector} from 'react-redux';

import {setDate, setTime} from '@/actions/timeZoneAction';
import {changeAutoSync} from '@/businesses/timeZoneBusiness';
import DateTimePicker from '@/components/dateTimePicker/DateTimePicker';
import Input from '@/components/input/Input';
import Switch from '@/components/switch/Switch';
import {DEVICE_DATE, DEVICE_TIME, FIELD_NAME, TIMEZONE_SETTING_ADDRESS} from '@/constants/pcConstAppData';
import {COLUMN_2, COLUMN_3, COLUMN_9, COLUMN_FULL} from '@/constants/pcConstAppStyle';
import useIntlFormat from '@/hooks/useIntlFormat';
import {navigateTo} from '@/libs/appHelper';
import {getFormattedDate, getFormattedTime, isValidDate, normalizeDate, normalizeTime} from '@/libs/dateHelper';
import {getLicenseType} from '@/selectors/deviceInfoSelector';
import {getDeviceSettingDateTime} from '@/selectors/timeZoneSelector';

import './DeviceSettingDateTime.scss';

function DeviceSettingDateTime() {
  const {formatMessage} = useIntlFormat();
  const dispatch = useDispatch();
  const {isAutoSync, timeZone, date, time} = useSelector(getDeviceSettingDateTime);
  const licenseType = useSelector(getLicenseType);

  const [idDatePicker, setIdDatePicker] = useState('date-picker');
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [dateFormatDatePicker, setDateFormatDatePicker] = useState(false);
  const [timeFormatDatePicker, setTimeFormatDatePicker] = useState(false);
  const [valueDatePicker, setValueDatePicker] = useState('');

  const handleAutoSyncTimeZoneChange = (checked) => dispatch(changeAutoSync(checked));

  const handleTimeZoneInputClick = () => navigateTo(TIMEZONE_SETTING_ADDRESS);

  const handleDateInputClick = (e) => {
    setIdDatePicker(e.target.id);
    setTimeFormatDatePicker(false);
    setDateFormatDatePicker(DateTimePicker.format.date);
    setValueDatePicker(normalizeDate(e.target.value));
    setShowDatePicker(true);
  };

  const handleTimeInputClick = (e) => {
    setIdDatePicker(e.target.id);
    setTimeFormatDatePicker(true);
    setDateFormatDatePicker(false);
    setValueDatePicker(normalizeTime(e.target.value));
    setShowDatePicker(true);
  };

  const handleDateTimePickerClose = (id, value) => {
    switch (id) {
      case DEVICE_DATE:
        dispatch(setDate(isValidDate(value) ? getFormattedDate(value) : value));

        break;
      case DEVICE_TIME:
        // close the modal
        break;
      default:
        break;
    }

    setShowDatePicker(false);
  };

  const handleDateTimePickerApply = (id, value) => {
    switch (id) {
      case DEVICE_DATE:
        // not handled
        break;
      case DEVICE_TIME:
        dispatch(setTime(isValidDate(value) ? getFormattedTime(value) : value));
        break;
      default:
        break;
    }

    setShowDatePicker(false);
  };

  return (
    <div className={`${COLUMN_FULL} rowHeight device-setting-date-time `}>
      <div className={`${COLUMN_3} `}>{formatMessage({id: 'deviceSetting.label.dateTime'})}</div>
      <div className={`${COLUMN_9} row rowMargin timezone-field `}>
        <div className={`${COLUMN_2} row timezone-toggle `}>
          <Switch
            onChange={handleAutoSyncTimeZoneChange}
            checked={isAutoSync}
            onColor="#E38006"
            offColor="#A8A8A8"
            width={74}
            height={32}
          />
        </div>
        <div
          className={`${COLUMN_9} row timezone-form ${
            licenseType === FIELD_NAME.LICENSE.TYPE.TEMPORARY ? 'pointer-none' : ''
          }`}
        >
          <div>{formatMessage({id: 'deviceSetting.label.dateTimeTimezone'})}</div>
          <Input
            id="time-zone"
            disabled={isAutoSync}
            onClick={handleTimeZoneInputClick}
            readOnly
            value={timeZone}
          />
          <div className=" timezone-form-date-time">
            <Input
              id={DEVICE_DATE}
              disabled={isAutoSync}
              onClick={handleDateInputClick}
              readOnly
              value={date}
              icon="calendar"
            />
            <Input
              id={DEVICE_TIME}
              disabled={isAutoSync}
              onClick={handleTimeInputClick}
              readOnly
              value={time}
              icon="time"
            />
          </div>
        </div>
      </div>

      <DateTimePicker
        id={idDatePicker}
        showDateTime={showDatePicker}
        onClose={handleDateTimePickerClose}
        onApplyTime={handleDateTimePickerApply}
        dateFormat={dateFormatDatePicker}
        timeFormat={timeFormatDatePicker}
        value={valueDatePicker}
        className={timeFormatDatePicker ? 'device-setting-date-time-picker' : ''}
      />
    </div>
  );
}

export default DeviceSettingDateTime;
